import { NSButtonOnClickProps, NSMenuActionProps } from "namirasoft-site-react";
import { NSARouterMakerProps } from "../NSARouterMakerProps";
import { IEntityInfo } from "../IEntityInfo";
import { EnvService, FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftHistoryMetaDatabase } from "namirasoft-history";

export class Actions
{
    static 
    apply(onClick: NSButtonOnClickProps): NSMenuActionProps
    {
        return {
            id: "0",
            menu_item: "Apply",
            onClick,
            isActive() { return true; }
        }
    }
    static _new(props: NSARouterMakerProps, entity: IEntityInfo<any>): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New",
            onClick: {
                action: () =>
                {
                    if (entity.client.getNewURL)
                    {
                        let link = props.url.getLink(entity.client.getNewURL(), {});
                        window.open(link, "_blank");
                    }
                },
                showLoading: false
            },
            isActive() { return true; }
        };
    }
    static list(props: NSARouterMakerProps, entity: IEntityInfo<any>): NSMenuActionProps
    {
        return {
            id: "2",
            menu_item: "List",
            onClick: {
                action: () =>
                {
                    if (entity.client.getListURL)
                    {
                        let link = props.url.getLink(entity.client.getListURL(), {});
                        window.open(link, "_blank");
                    }
                },
                showLoading: false
            },
            isActive() { return true; }
        };
    }
    static view(props: NSARouterMakerProps, entity: IEntityInfo<any>, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "3",
            menu_item: "View",
            onClick: {
                action: () =>
                {
                    if (entity.client.getViewURL)
                    {
                        let ids = getIDs();
                        let link = props.url.getLink(entity.client.getViewURL(ids[0]), {});
                        window.open(link, "_blank");
                    }
                },
                showLoading: false
            },
            isActive() { return getIDs().length === 1; }
        };
    }
    static viewHistory(getIDs: () => string[]): NSMenuActionProps
    {
        let REACT_APP_BASE_URL_HISTORY_CONSOLE = new EnvService("REACT_APP_BASE_URL_HISTORY_CONSOLE", true,).getString();
        return {
            id: "4",
            menu_item: "View History",
            onClick: {
                action: () =>
                {
                    let meta = new NamirasoftHistoryMetaDatabase();
                    let filters: FilterItem[] = [];
                    filters.push(new FilterItem(meta.tables.history, meta.tables.history.columns.entity_id, false, FilterItemOperator.all.equals, getIDs()[0]));
                    let encoded = FilterItem.encode(filters);
                    window.open(REACT_APP_BASE_URL_HISTORY_CONSOLE + "/history/list?filters=" + encoded, "_blank");
                },
                showLoading: false
            },
            isActive() { return getIDs().length === 1; }
        };
    }
    static copy(props: NSARouterMakerProps, entity: IEntityInfo<any>, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "5",
            menu_item: "Copy",
            onClick: {
                action: () =>
                {
                    if (entity.client.getCopyURL)
                    {
                        let ids = getIDs();
                        let link = props.url.getLink(entity.client.getCopyURL(ids[0]), {});
                        window.open(link, "_blank");
                    }
                },
                showLoading: false
            },
            isActive() { return getIDs().length === 1; }
        };
    }
    static edit(props: NSARouterMakerProps, entity: IEntityInfo<any>, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "6",
            menu_item: "Edit",
            onClick: {
                action: () =>
                {
                    if (entity.client.getEditURL)
                    {
                        let ids = getIDs();
                        let link = props.url.getLink(entity.client.getEditURL(ids[0]), {});
                        window.open(link, "_blank");
                    }
                },
                showLoading: false
            },
            isActive() { return getIDs().length === 1; }
        };
    }
    static delete(getIDs: () => string[], onClick: NSButtonOnClickProps): NSMenuActionProps
    {
        return {
            id: "7",
            menu_item: "Delete",
            onClick,
            isActive() { return getIDs().length !== 0; }
        }
    }
}